import styled from "styled-components";

const BubbleTextForPageHeader = styled.div`
  padding: 5px 20px;
  background-color: var(--surface);
  font-size: 14px;
  border-radius: 10px;
  color: var(--elementDim);
  font-weight: 700;
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: capitalize;
`;

export default BubbleTextForPageHeader;
